module.exports = __webpack_public_path__ + "assets/img/Fotolia_77899752_XS.1d8fb8b8.jpg";